import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { Link } from 'gatsby';

import { accentLink } from '../../style/link';
import { breakpoint } from '../../style/utils';
import { colours, fonts, spacing } from '../../style/variables';
import { Logo } from '../Logo';

interface NavbarStyleProps {
  overlay: boolean;
}

const absoluteStyles = css`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
`;

export const NavbarRoot = styled.nav<NavbarStyleProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 72px;
  background-color: ${({ overlay }) => (overlay ? 'transparent' : colours.cream)};
  ${({ overlay }) => overlay && absoluteStyles};
  z-index: 1;
  padding: 0 32px;

  @media ${breakpoint({ max: 'xs' })} {
    height: ${spacing.navbarHeight}px;
  }
`;

export const NavbarLinks = styled.ul`
  flex: 1 0 0;
  margin: 0;
  padding: 0;
`;

interface ExternalNavbarLinkProps {
  hideOnMobile?: boolean;
}

export const ExternalNavbarLink = styled.a<ExternalNavbarLinkProps>`
  ${accentLink};
  color: ${colours.primary};
  font-family: ${fonts.body};
  font-size: 16px;
  font-weight: 500;
  text-decoration: none;

  ${({ hideOnMobile }) =>
    hideOnMobile &&
    css`
      @media ${breakpoint({ max: 'lg' })} {
        display: none;
      }
    `}

  &:not(:last-of-type) {
    margin-right: 16px;
  }
`;

export const NavbarLogoLink = styled(Link)`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  line-height: 0;
  z-index: 1;

  &:hover {
    transform: translate(-50%, -50%) scale(0.95);
  }

  @media ${breakpoint({ max: 'sm' })} {
    display: none;
  }
`;

export const NavbarLogo = styled(Logo)`
  display: block;
`;

export const NavbarRight = styled.div`
  flex: 1 0 0;
  @media ${breakpoint({ max: 'sm' })} {
    display: none;
  }
`;
